<template>
  <div class="mb-2">
    <b-navbar toggleable="lg" type="light" variant="light">
      <Sidebar />
      <b-navbar-toggle target="nav-collapse" />

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav />
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown :text="adminData().admin.email" right>
            <router-link class="dropdown-item" to="/account"
              >Minha conta</router-link
            >
            <b-dropdown-item v-on:click="logout" href="#">
              Sair
              <span class="fa fa-sign-out"></span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>


<script>
import routes from "../routes";

import Sidebar from "./Sidebar";
import { adminData } from "../lib/functions";
import api from "../services/api";

export default {
  name: "NavBar",
  components: {
    Sidebar,
  },
  methods: {
    adminData,
    async logout() {
      try {
        await api.get("/logout");
      } catch (error) {
        console.log(error);
      } finally {
        sessionStorage.clear();
        routes.push({ name: "signin" });
      }
    },
  },
};
</script>
